export enum BookingDetailsDataHook {
  ACCORDION = 'booking-details-accordion',
  SECTION_TITLE = 'booking-details-section-title',
}
